import Spinner from "./Spinner";

export default function PageLoader({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="page-shell flex min-h-[50vh] items-center justify-center">
      <Spinner label={label} />
    </div>
  );
}
